<div class="container">
    @if (!loginSuccessful) {
        <p>{{ 'loginCallback.loginFailed' | translate }}</p>

        <p-button routerLink="/home" label="{{ 'loginCallback.returnToHome' | translate }}"></p-button>
    }
</div>